<template>
    <section class="lymphomap_main">
        <div class="ai_use_models_wrp">
            <div class="model_predication_card">
                <div class="model_predication_card_inner">
                    <div class="model_predication_heading mb-3">
                        <div class="row">
                            <div class="col-auto pr-0"><button type="button" class="btn back_btn"
                                    @click="$router.go(-1)"><i aria-hidden="true"
                                        class="fa fa-chevron-left"></i></button>
                            </div>
                            <div class="col pl-0">
                                <h2 class="model_predication_heading_text">Use Model</h2>
                            </div>
                        </div>
                    </div>
                    <model-info :modelInfo="selectedModelDetails"></model-info>
                    <div class="model_predication_form_wrp mt-5">
                        <h3 class="model_predication_heading">Model Predication</h3>
                        <div class="model_predication_form_inner_box">
                            <div class="patient_selection_tab mb-4">
                                <div class="row">
                                    <div class="col-12 col-sm text-center" v-if="selectedModelDetails">
                                        <label class="patient_selection_label_wrp" v-if="isBatch">
                                            <!-- <input type="radio" id="batch_patient" name="type" v-model="selection_type" value="batch_patient" v-on:click="selectedOptionMethod('batch_patient')"> -->
                                            <label class="patient_selection_label" for="batch_patient">
                                                <div class="label_box"><span></span>Batch Patients Data</div>
                                            </label>
                                        </label>
                                        <label class="patient_selection_label_wrp" v-else>
                                            <!-- <input type="radio" id="single_patient" name="type" v-model="selection_type" value="single_patient" v-on:click="selectedOptionMethod('single_patient')"> -->
                                            <label class="patient_selection_label active" for="single_patient">
                                                <div class="label_box"><span></span>Single Patients Data</div>
                                            </label>
                                        </label>
                                    </div>
                                    <!-- <div class="col-12 col-sm text-center text-sm-left pl-sm-0 mt-3 mt-sm-0">
                                            <label class="patient_selection_label_wrp">
                                            <input type="radio" id="batch_patient" name="type" v-model="selection_type" value="batch_patient" v-on:click="selectedOptionMethod('batch_patient')">
                                            <label class="patient_selection_label" for="batch_patient">Batch Patients Data<span></span></label>
                                            </label>
                                        </div> -->
                                </div>
                            </div>
                            <div class="patient_selection_form_wrp" v-if="selectedModelDetails">
                                <batch-patient v-bind:selectedModelInfo="selectedModelDetails"
                                    v-if="isBatch"></batch-patient>
                                <single-patient v-bind:selectedModelInfo="selectedModelDetails" v-else></single-patient>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-sm-6 pl-sm-2">
                    <right-sidebar :modelInfo="selectedModelDetails"></right-sidebar>
                </div> -->
        </div>
    </section>
</template>

<script>
/*eslint-disable */

import axios from 'axios';
import batchPatient from '@/components/private/ai-dashboard/batch-patients-data-use/';
import {
    mapGetters,
} from 'vuex';
import modelPredicationRightSidebar from '@/components/private/ai-dashboard/model-predication-right-sidebar/';
import singlePatient from '@/components/private/ai-dashboard/signle-patient-data-use/';
import modelInfo from './modelInfo.vue';

export default {
    name: 'new-model-use',
    components: {
        'single-patient': singlePatient,
        'batch-patient': batchPatient,
        'right-sidebar': modelPredicationRightSidebar,
        'model-info': modelInfo
    },
    props: [],
    data() {
        return {
            submitted: false,
            selectedModelId: '',
            model_name: '',
            selectedModelDetails: null,
            selection_type: 'single_patient',
            isBatch: false,
            publicModelIdHardcode: ''
        }
    },
    computed: {
        ...mapGetters([
            'getModelsDetailsByIdGetters'
        ]),
        getModelInfoByIdFun() {
            return this.$store.getters.getModelsDetailsByIdGetters;
        },
    },
    mounted() {
        this.publicModelIdHardcode = process.env.VUE_APP_PUBLIC_AI_MODEL_ID;
        this.selectedModelId = this.$route.params.useModelsId;
        this.selectedModelDetails = this.$store.getters.getModelsDetailsByIdGetters.data;
        if (this.selectedModelDetails) {
            this.model_name = this.selectedModelDetails.name;
            this.isBatch = this.selectedModelDetails.is_batch;
        }
    },
    methods: {
        nextDescribeListMethod(url) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    axios.get(url).then((response) => {
                        this.labelDescListNext = response.data.data.next
                        this.labelDescList = [].concat(this.labelDescList, response.data.data.results);
                        this.submitted = false
                    });
                    return;
                }
            })
        },
        selectedOptionMethod(item) {
            this.selection_type = item
        }
    },
    watch: {
        getModelInfoByIdFun(newVal, oldVal) {
            this.selectedModelDetails = newVal.data;
            if (this.selectedModelDetails) {
                this.model_name = this.selectedModelDetails.name;
                this.isBatch = this.selectedModelDetails.is_batch;
            }
        }
    },
}
</script>


<style lang="scss" scoped>
.ai_use_models_wrp {
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    letter-spacing: 0.5px;

    .model_predication_card_inner {
        background: rgba(0, 0, 0, .75);
        box-shadow: -5px 5px 10px rgba(138, 145, 153, 0.06);
        padding: 10px;
        border-radius: 4px;
        height: 100%;
    }

    .model_predication_heading_text {
        color: #ffffff;
        font-size: 24px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
    }

    .models_searchbar {
        position: relative;

        .fa {
            font-size: 18px;
            cursor: pointer;
            color: #c0c0c0;
            position: absolute;
            top: 8px;
            left: 10px;
        }

        .form-control {
            background: rgba(255, 255, 255, 0.1);
            font-size: 18px;
            color: #fff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            border: none;
            height: auto;
            width: 320px;
            line-height: 36px;
            padding: 0px 15px 0 40px;
            -webkit-box-shadow: none;
            box-shadow: none;

            &::-moz-placeholder {
                color: #dfdfdf;
            }

            &::-webkit-input-placeholder {
                color: #dfdfdf;
            }

            &:focus::-webkit-input-placeholder {
                font-size: 0px;
            }

            &:focus::-moz-placeholder {
                font-size: 0px;
            }
        }
    }

    .ai_task_dash_count_box_inner {
        background: rgba(228, 233, 237, 0.1);
        padding: 35px 20px;
        border-radius: 5px;
        cursor: pointer;
        color: #fff;
        text-align: center;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        &:hover {
            background: #87cefa;
            color: #000000;
        }

        span {
            display: block;

            &.ai_task_dash_count_num {
                font-size: 22px;
                font-weight: bold;
            }

            &.ai_task_dash_count_name {
                font-size: 20px;
            }
        }
    }

    .un_in_ai_dashboard {
        color: #c4c4c4;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 14px;
    }

    .task_models_tab_list {
        margin: 0 0 5px;
        display: flex;

        .task_models_tab_list_item {
            font-size: 18px;
            color: #fffcc4;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            margin-right: 20px;
            cursor: pointer;

            a {
                text-decoration: none;
                color: #ffffff;
            }

            &:hover {
                color: #87cefa;
            }

            &:hover a {
                color: #87cefa;
            }

            &.active {
                color: #87cefa;
            }
        }
    }

    .models_tab_content {
        .table {
            margin-bottom: 0;
            letter-spacing: 0.5px;
            color: #ffffff;
            border-collapse: separate;
            border-spacing: 0 3px;

            thead th {
                border-bottom: 0;
                font-size: 18px;
                padding: 10px 8px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                text-transform: uppercase;
                border-top: 0px;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                background: rgba(228, 233, 237, 0.1);
                color: #87cefa;
            }

            tbody td {
                color: #ffffff;
                vertical-align: middle;
                padding: 10px 8px;
                font-size: 18px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                border-top: 0px;
                background: rgba(228, 233, 237, 0.1);

                .btn-primary {
                    padding: 6px 20px;
                    font-size: 16px;
                    border-radius: 70px;
                    background: rgba(255, 255, 255, 0.12);
                    color: #ffd400;
                    border: none;
                    margin-right: 5px;
                    text-transform: capitalize;
                    font-weight: 400;
                    letter-spacing: .03em;
                    line-height: 1;
                    transition: all ease 0.5s;
                    -webkit-transition: all ease 0.5s;
                    -moz-transition: all ease 0.5s;
                    box-shadow: none;

                    &:hover {
                        background: #87cefa;
                        color: #22292f;
                    }
                }

                /* Toggle button styles */
                .onoffswitch {
                    position: relative;
                    width: 80px;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                }

                .onoffswitch-checkbox {
                    display: none;
                }

                .onoffswitch-label {
                    display: block;
                    overflow: hidden;
                    cursor: pointer;
                    border: 0px solid #999999;
                    border-radius: 20px;
                    margin: 0;
                }

                .onoffswitch-inner {
                    display: block;
                    width: 200%;
                    margin-left: -100%;
                    transition: margin 0.3s ease-in 0s;
                }

                .onoffswitch-inner:before,
                .onoffswitch-inner:after {
                    display: block;
                    float: left;
                    width: 50%;
                    height: 25px;
                    padding: 0;
                    line-height: 25px;
                    font-size: 14px;
                    color: white;
                    font-weight: 400;
                    box-sizing: border-box;
                }

                .onoffswitch-inner:before {
                    content: "Public";
                    padding-left: 10px;
                    background-color: #36B04C;
                    color: #FFFFFF;
                }

                .onoffswitch-inner:after {
                    content: "Private";
                    padding-right: 10px;
                    background-color: #DA1B22;
                    color: #FFFFFF;
                    text-align: right;
                }

                .onoffswitch-switch {
                    display: block;
                    width: 17px;
                    margin: 4px;
                    background: #FFFFFF;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    right: 55px;
                    border: 0px solid #999999;
                    border-radius: 13px;
                    transition: all 0.3s ease-in 0s;
                }

                .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
                    margin-left: 0;
                }

                .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
                    right: 0px;
                }

                .models_pu_toggle {
                    display: inline-block;
                    vertical-align: middle;
                }
            }
        }
    }

    .user_info_for_ai_task {
        text-align: center;

        .ai_user_info_avtaar .img-fluid {
            width: 140px;
            height: 140px;
            border-radius: 50%;
            border: 3px solid #c4c4c4;
        }

        .ai_user_info_name {
            font-size: 24px;
        }

        .ai_user_info_email {
            font-size: 16px;
            color: #d6d6d6;
        }

        .ai_user_info_mo_nu {
            font-size: 16px;
            color: #d6d6d6;
        }

        .ai_user_info_desg {
            font-size: 16px;
            color: #d6d6d6;
        }
    }

    .recent_pretrained_models_wrp {
        .recent_pretrained_models_heading {
            font-size: 22px;
            color: #ffffff;
            text-transform: uppercase;
            text-decoration: underline;
        }

        .recent_pretrained_models_list_items {
            background: rgba(228, 233, 237, 0.1);
            padding: 5px;
            margin-bottom: 3px;

            &:last-child {
                margin-bottom: 0px;
            }

            span {
                display: block;
                color: #fff8d8;
                font-size: 14px;

                &.recent_pretrained_models_name {
                    color: #87cefa;
                    font-size: 16px;
                }
            }
        }

        .recent_pretrained_models_action {
            .btn-primary {
                padding: 6px 20px;
                font-size: 16px;
                border-radius: 70px;
                background: rgba(255, 255, 255, 0.12);
                color: #ffd400;
                border: none;
                text-transform: capitalize;
                font-weight: 400;
                letter-spacing: .03em;
                line-height: 1;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                box-shadow: none;

                &:hover {
                    background: #87cefa;
                    color: #22292f;
                }
            }

            .recent_pretrained_models_name {
                color: #87cefa;
                font-size: 16px;
            }
        }
    }

    .model_predication_form_wrp {
        .model_predication_heading {
            margin-bottom: 20px;
            font-size: 30px;
            color: #ffc107;
        }

        .model_predication_form_inner_box {
            max-width: 100%;
            border-radius: 5px;
            padding: 40px;
            margin: 0 auto;
            flex: 0 0 100%;
            background: rgba(26, 26, 26, 0.5);
            border: 1px solid rgba(93, 93, 93, 0.4);
            border-radius: 32px;

            @media only screen and (max-width:769px) {
                padding: 15px;
            }

            label {
                font-size: 18px;
                margin-bottom: 5px;
                color: #efefef;
                letter-spacing: 0.5px;

                &.text_overflow {
                    margin-bottom: 0;
                    white-space: nowrap;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: 16px;

                    &:first-letter {
                        text-transform: uppercase;
                    }
                }
            }

            .form-control {
                width: 100%;
                height: 44px;
                font-weight: 400;
                font-size: 18px;
                border-radius: 5px;
                padding: 0px 20px;
                border: 1px solid rgba(255, 255, 255, 0.1);
                outline: none !important;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                color: #ffd400;
                line-height: 1;
                background: rgba(255, 255, 255, 0.08);

                &:hover {
                    border-color: #ffd400;
                }
            }

            .mx-datepicker {
                width: 100%;
            }

            .invalid-feedback {
                font-size: 14px;
                line-height: 1;
                font-weight: 600;
                color: #ff3a30;
            }

            .btn-primary {
                cursor: pointer;
                position: relative;
                min-width: 95px;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                outline: none !important;
                background: rgba(255, 18, 18, 0.5) !important;
                color: #ffffff !important;
                border: none;
                border-radius: 3px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 18px;

                &:hover {
                    background: #ffe738 !important;
                    color: #22292f !important;
                }
            }

            .custom_select_dropdown {
                outline: none;
            }

            .custom_select_dropdown .form_control {
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                background-color: rgba(255, 255, 255, 0.1);
            }

            .custom_select_dropdown .dropdown-menu {
                height: 260px;
                margin: 0;
                width: 100%;

                &::-webkit-scrollbar {
                    width: 5px;
                    background: transparent;
                }

                &::-webkit-scrollbar-thumb {
                    background-color: #333333;
                    border-radius: 8px;
                }
            }

            .select_alogrithm_dd .custom_select_dropdown .dropdown-menu {
                height: 130px;
            }
        }

        .upload_data_file {
            input[type='file'] {
                display: none;
            }

            .task_custom_tooltip_wrp {
                position: relative;
                display: block;

                .upload_file_btn {
                    background: #ff3a30;
                    cursor: pointer;
                    position: relative;
                    color: #fff;
                    width: 120px;
                    padding: .375rem 8px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;

                    &:hover {
                        background: #87cefa;
                        color: #000;
                    }
                }

                .task_custom_tooltip {
                    color: #000000;
                    font-size: 15px;
                    position: absolute;
                    background: #ffdee3;
                    width: 280px;
                    left: calc(100% + 8px);
                    padding: 5px;
                    top: 0px;
                    display: none;
                    cursor: default;
                    z-index: 999;
                    border-radius: 2px;
                    font-weight: 600;
                    line-height: 1;
                    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;

                    &:before {
                        border: solid;
                        border-color: #ffdee3 transparent;
                        border-width: 12px 12px 0px 0px;
                        top: 13px;
                        content: "";
                        display: block;
                        left: -6px;
                        position: absolute;
                        z-index: 1000;
                        -moz-transform: rotate(-45deg);
                        -webkit-transform: rotate(-45deg);
                        transform: rotate(-45deg);
                    }
                }

                &:hover .task_custom_tooltip {
                    display: block;
                }
            }
        }

        .upload_attachment_btn {
            label {
                position: relative;
                padding: 10px 15px;
                background: rgba(255, 255, 255, 0.1);
                margin: 0;
                line-height: 1;
                border-radius: 3px;
                color: #fff;
                cursor: pointer;
                margin-bottom: 0px !important;
                word-break: break-all;
            }

            input[type="file"] {
                position: absolute;
                opacity: 0;
                display: none;
            }

            .task_custom_tooltip {
                color: #000000;
                font-size: 15px;
                position: absolute;
                background: #ffdee3;
                width: 280px;
                left: calc(100% + 8px);
                padding: 5px;
                top: 0px;
                display: none;
                cursor: default;
                z-index: 999;
                border-radius: 2px;
                font-weight: 600;
                line-height: 1;
                font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;

                &:before {
                    border: solid;
                    border-color: #ffdee3 transparent;
                    border-width: 12px 12px 0px 0px;
                    top: 13px;
                    content: "";
                    display: block;
                    left: -6px;
                    position: absolute;
                    z-index: 1000;
                    -moz-transform: rotate(-45deg);
                    -webkit-transform: rotate(-45deg);
                    transform: rotate(-45deg);
                }
            }

            &:hover .task_custom_tooltip {
                display: block;
            }
        }

        .tained_alert_msg {
            font-size: 20px;
            text-align: center;
            margin-bottom: 30px;
            font-weight: normal;
            color: #fffcc4;
            line-height: 1.3;
        }

        .patient_selection_tab {
            .patient_selection_label_wrp {
                position: relative;
                margin: 0px;

                input[type="radio"] {
                    display: none;
                }

                .patient_selection_label {
                    margin: 0px;
                    background: #8b044f;
                    padding: 5px 15px;
                    border-radius: 60px;
                    font-size: 15px;
                    color: #ffffff;
                    position: relative;
                    cursor: pointer;
                    .label_box {
                        position: relative;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                    span {
                        width: 12px;
                        height: 12px;
                        background: #e1e1e1;
                        display: block;
                        border-radius: 50%;
                        // position: absolute;
                        // left: 7px;
                        // top: 9px;
                    }
                }

                input[type="radio"]:checked+.patient_selection_label {
                    background: #2d9901;
                    color: #ffffff;

                    span {
                        background: #ffffff;
                    }
                }

                .patient_selection_label.active {
                    background: #2d9901;
                    color: #ffffff;

                    span {
                        background: #ffffff;
                    }
                }
            }
        }
    }

    .model_details_inner_wrp {
        ul {
            margin: 0;
        }

        li {
            margin-bottom: 5px;
            display: flex;
        }

        span {
            font-size: 17px;

            &.model_details_key {
                width: 240px;
                flex: 0 0 240px;
                color: #ffd400;
            }

            &.model_details_val {
                color: #8f8f8f;
                font-size: 16px;
                line-height: 1.2;
            }
        }

        .btn-primary {
            cursor: pointer;
            position: relative;
            min-width: 95px;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            outline: none !important;
            background: rgba(255, 255, 255, 0.12) !important;
            color: #fffcc4 !important;
            border: none;
            border-radius: 3px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 16px;
            padding: 4px 0;

            &:hover {
                background: #87cefa !important;
                color: #22292f !important;
            }
        }

        &.describe_list_info ul {
            // display: flex;
            // -webkit-box-orient: vertical;
            // -webkit-box-direction: normal;
            // -ms-flex-direction: column;
            // flex-direction: column;
        }
    }

    .center_container_sm {
        max-width: 380px;
        margin: 0 auto;
    }
}
</style>